import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-bottom: 6rem;
  text-align: center;
`;

export const Heading = styled.h1`
  text-align: center;
  padding-top: 6rem;
`;

export const Container = styled.div`
  text-align: center;
`;

export const UlList = styled.ul`
  list-style: none;
  padding: 0;
  font-weight: 600;
`;
